import { IonIcon } from '@ionic/react';
import { checkmark, optionsOutline } from 'ionicons/icons';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { SearchCategory, SearchResultType } from '../../model/models';
import EventsResults from './EventsResults';
import NewsResults from './NewsResults';
import PlacesResults from './PlacesResults';
import ServicesResults from './ServicesResults';
import UsersResults from './UsersResults';

const SEE_MORE_STYLE: string =
  'cursor-pointer text-primary font-medium text-sm';

interface CategoryResultsProps {
  category: SearchCategory;
  items: Array<SearchResultType>;
  more?: (
    category: SearchCategory,
    maxMore?: number
  ) => Promise<void> | undefined;
  hasMore: boolean;
  isSearch: boolean;
  isFilter?: boolean;
  openModal?: (boolean) => void;
}

export const CategoryResults = ({
  category,
  items,
  more,
  hasMore,
  isSearch,
  isFilter,
  openModal,
}: CategoryResultsProps) => {
  const renderSwitch = (category) => {
    switch (category) {
      case 'news':
        return <NewsResults items={items} />;
      case 'events':
        return <EventsResults items={items} />;
      case 'services':
        return <ServicesResults items={items} />;
      case 'users':
        return <UsersResults items={items} />;
      case 'places':
        return <PlacesResults items={items} />;
      default:
        return <FormattedMessage id={`Non implementé`} />;
    }
  };

  const showMoreResults = more === undefined && hasMore;

  return (
    <>
      {isSearch && items.length > 0 && (
        <div className="w-full bg-white rounded-3xl md:p-8">
          <div className="relative w-full flex justify-between items-center">
            <h2 className="text-left font-bold">
              <FormattedMessage id={`Search #${category}`} />
              {showMoreResults && (
                <span className={`absolute right-0 ${SEE_MORE_STYLE}`}>
                  <Link to={`/search/${category}`}>
                    <FormattedMessage id="See All Results" />
                  </Link>
                </span>
              )}
            </h2>
            {!showMoreResults &&
              category === 'users' &&
              openModal !== undefined && (
                <button onClick={() => openModal(true)}>
                  <div className="bg-primary rounded-3xl px-2 py-2 flex justify-center items-center">
                    <IonIcon
                      icon={optionsOutline}
                      className="text-white  transform -rotate-90"
                    />
                    <p className="text-xs text-white uppercase font-bold pl-1">
                      <FormattedMessage id="Filter" />
                    </p>
                    {isFilter && (
                      <div className="w-5 h-5 rounded-full bg-black flex justify-center items-center ml-2">
                        <IonIcon
                          icon={checkmark}
                          className="text-lg text-white w-3 h-3"
                        />
                      </div>
                    )}
                  </div>
                </button>
              )}
          </div>
          <div className="w-full py-4 text-justify">
            {renderSwitch(category)}
          </div>
          {more !== undefined && hasMore === true && (
            <div
              className={`px-4 py-2 ${SEE_MORE_STYLE}`}
              onClick={() => more(category)}
            >
              <FormattedMessage id="Search More" />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CategoryResults;
